import dev from '../environment/dev.json';
import preview from '../environment/preview.json';
import live from '../environment/live.json';
export const updateUrlForHost = (url) => {
    const currentHost = window?.location?.host ?? '';
    if (currentHost.includes('.at')) {
        return url.replace('immowelt.de', 'immowelt.at');
    }
    return url;
};
export function readEnvFile() {
    const config = {
        preview,
        dev,
        live,
    };
    const stage = process.env.ENVIRONMENT ?? 'dev';
    return config[stage];
}
const { DISPATCHER_BFF_URL, CAF2010Url } = readEnvFile();
export const getUrlWithParams = (url) => {
    if (url !== CAF2010Url)
        return url;
    const currentUrl = new URL(window.location.href);
    const caf2010Url = new URL(updateUrlForHost(url));
    caf2010Url.search = new URLSearchParams(currentUrl.search).toString();
    return updateUrlForHost(caf2010Url.toString());
};
export const getCookie = (name) => document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`))
    ?.split('=')[1] ?? '';
export const baseFetch = async (url) => {
    const response = await fetch(url, {
        headers: {
            Authorization: getCookie('oauth.access.token'),
        },
    });
    if (!response.ok) {
        throw new Error(`Network response was not ok for ${url}`);
    }
    return await response.json();
};
const fetchUrl = async (url) => {
    try {
        const { data } = await baseFetch(url);
        return data.url;
    }
    catch (error) {
        console.error(error);
        return CAF2010Url;
    }
};
export const retrieveURLUponSelection = async (estateType, transactionType) => {
    const params = new URLSearchParams();
    params.set('estateType', estateType);
    params.set('transactionType', transactionType);
    const url = `${DISPATCHER_BFF_URL}/dispatcher?${params.toString()}`;
    return fetchUrl(url);
};
export const fetchURLByClassifiedId = async (classifiedId) => {
    const url = `${DISPATCHER_BFF_URL}/dispatcher?classifiedId=${classifiedId}`;
    return fetchUrl(url);
};
export const getCustomerType = async () => {
    const { CUSTOMER_TYPE_CHECK } = readEnvFile();
    if (!CUSTOMER_TYPE_CHECK)
        return 'COMMERCIAL';
    const url = `${DISPATCHER_BFF_URL}/customer-type`;
    try {
        const { data } = await baseFetch(url);
        const { registrationType } = data;
        return registrationType;
    }
    catch (error) {
        console.error(error);
        return '';
    }
};
const transactionTypeMapping = {
    '1': 'BUY',
    '2': 'RENT',
};
const propertyTypeMapping = {
    '1': 'APARTMENT',
    '2': 'HOUSE',
    '3': 'PLOT',
    '4': 'OFFICE',
    '5': 'TRADING',
    '6': 'STORAGE_PRODUCTION',
    '7': 'PLOT',
    '8': 'TRADING',
    '9': 'MISCELLANEOUS',
    '10': 'GASTRONOMY_HOTEL',
    '11': 'AGRICULTURE_FORESTRY',
    '13': 'PARKING',
    '15': 'MISCELLANEOUS',
    '16': 'MISCELLANEOUS',
};
export const getTransactionType = (transactionType) => {
    return transactionTypeMapping[transactionType];
};
export const getPropertyType = (propertyType) => {
    return propertyTypeMapping[propertyType];
};
const getKeyByValue = (object, value) => {
    return Object.entries(object).find(([, val]) => val === value)?.[0];
};
export const getTransactionTypeKey = (transactionType) => {
    return getKeyByValue(transactionTypeMapping, transactionType) ?? '';
};
export const getPropertyTypeKey = (propertyType) => {
    return getKeyByValue(propertyTypeMapping, propertyType) ?? '';
};
export const getEnriched2010Url = ({ searchParams, transactionType, propertyType, }) => {
    const urlParams = new URLSearchParams(searchParams);
    urlParams.set('etype', getPropertyTypeKey(propertyType));
    urlParams.set('esr', getTransactionTypeKey(transactionType));
    return `${updateUrlForHost(CAF2010Url)}?${urlParams.toString()}`;
};
